import { useState } from "react";

import { getSanitizedHtml } from "../../../handlers/utilityFunctions";
import Icon from "../../Icon";
import Tips from "../../Tips";

function NewInputField({
	onChange,
	value,
	id,
	name,
	type,
	placeholder,
	error,
	warn,
	disabled,
	label,
	onFocus,
	onKeyDown,
	onBlur,
	initialPasswordVisibilityStatus,
	onClick,
	iconLeft,
	disableCopyPaste,
	tips = null,
}) {
	const [passwordVisible, setPasswordVisible] = useState(initialPasswordVisibilityStatus);

	const togglePasswordVisibility = () => {
		const newVisibility = !passwordVisible;
		setPasswordVisible(newVisibility);
		onClick(newVisibility);
	};

	const handleCopyPaste = (event) => {
		if (disableCopyPaste) {
			event.preventDefault();
		}
	};

	return (
		<div className="relative mb-4">
			<div className="flex justify-between items-center mb-1">
				<label className="block text-sm font-medium text-gray-700">{label}</label>
				{tips && <Tips content={tips} />}
			</div>

			<div className="flex items-center relative">
				{iconLeft && (
					<span className="absolute left-3 flex items-center h-full text-gray-400">
						<Icon iconName={iconLeft} size={16} />
					</span>
				)}
				<input
					type={type === "password" && !passwordVisible ? "password" : "text"}
					className={`w-full py-1 px-3 ${iconLeft ? "pl-10" : ""} ${type === "password" ? "pr-10" : ""} rounded border border-gray-300 bg-transparent focus:outline-hidden focus:ring-2 focus:ring-blue-500 transition text-gray-900 disabled:bg-gray-100`}
					name={name}
					id={id}
					value={value}
					onChange={onChange}
					placeholder={placeholder}
					onFocus={onFocus}
					onBlur={onBlur}
					onKeyDown={onKeyDown}
					disabled={disabled}
					autoComplete="off"
					onCopy={handleCopyPaste}
					onPaste={handleCopyPaste}
				/>

				{type === "password" && (
					<span className="absolute right-3 flex items-center h-full">
						<button
							type="button"
							className="bg-transparent border-0 m-0 p-0 focus:outline-hidden"
							onClick={togglePasswordVisibility}
							tabIndex={-1}
						>
							<i className={`fa ${!passwordVisible ? "fa-eye" : "fa-eye-slash"} text-blue-600`} />
						</button>
					</span>
				)}
			</div>

			{error && (
				<div
					className="text-red-600 text-xs font-medium mt-1"
					dangerouslySetInnerHTML={{ __html: getSanitizedHtml(error) }}
				/>
			)}
			{warn && (
				<div
					className="text-yellow-600 text-xs font-medium mt-1"
					dangerouslySetInnerHTML={{ __html: getSanitizedHtml(warn) }}
				/>
			)}
		</div>
	);
}

export default NewInputField;
